import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    accordionOne: {
      text: 'A beneficial owner holds more than 25% of voting rights or capital or has control over the company.',
      title: 'What is a beneficial owner?',
    },
    accordionTwo: {
      link: 'Contact Us',
      text: 'To confirm a company as a beneficial owner, we need to discuss your situation together.',
      title: 'A company holds shares in your business',
    },
    accountHolder: 'Account holder',
    addBeneficiary: 'Add a beneficial owner',
    addedAllBeneficiaries: `I have added all beneficial owners of {businessName}`,
    buttons: {
      cta: 'Confirm beneficial owners',
      skip: 'Save and declare later',
    },
    confirmAddedAllBeneficiariesError:
      'Please confirm that you have added all of the beneficial owners',
    currentUserTitle: '{name} (You)',
    heading: 'Declare beneficial owners',
    otherBeneficiaries: 'Other beneficial owners',
  },
  fr: {
    accordionOne: {
      text: "Un bénéficiaire effectif détient plus de 25 % des droits de vote ou du capital, ou dispose d'un pouvoir de contrôle sur l'entreprise.",
      title: 'Qu’est ce qu’un bénéficiaire effectif ?',
    },
    accordionTwo: {
      link: 'Contactez-nous',
      text: 'Pour valider une société comme bénéficiaire effectif, nous devons étudier votre situation ensemble.',
      title: 'Une société détient des parts de votre entreprise  ',
    },
    accountHolder: 'Titulaire du compte',
    addBeneficiary: 'Ajouter un bénéficiaire effectif',
    addedAllBeneficiaries:
      'J’ai ajouté tous les bénéficiaires effectifs de {businessName}',
    buttons: {
      cta: 'Confirmer les bénéficiaires effectifs',
      skip: 'Enregistrer et déclarer plus tard',
    },
    confirmAddedAllBeneficiariesError:
      'Confirmez la liste des bénéficiaires effectifs',
    currentUserTitle: '{name} (Vous)',
    heading: 'Déclarez les bénéficiaires effectifs',
    otherBeneficiaries: 'Autres bénéficiaires effectifs',
  },
} as const);
